import { IProcessDocumentDeleteDialogProps } from "./ProcessDocumentDeleteDialog";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "@common/api/apiShared";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useProcessDocumentDeleteDialog(props: IProcessDocumentDeleteDialogProps) {
    const snackbar = useDotLegalSnackbar();

    const deleteMutation = useDotLegalMutation(deleteDocument);
    const deleteDocumentClick = (documentId: string) => {
        deleteMutation.mutateAsync(documentId!, {
            onSuccess: () => {
                props.onCloseDialog();
                props.onDeletedDocument();
                snackbar.show(createElement(Trans, { i18nKey: "documentDeleted", values: { document: props.selectedDocument!.name } }));
            },
        });
    };

    function deleteDocument(documentId: string) {
        return deleteHttp<string>(`/processes/${props.processId}/documents/${documentId}`);
    }

    return {
        deleteDocumentClick,
        inProgress: deleteMutation.isLoading,
    };
}
